"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyMenuConfigurationLayout = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyLayout_1 = require("./SankeyLayout");
const OpenSankeyMenuConfigurationLayout = (t, data, set_data, user_scale, set_user_scale, maximum_flux, set_maximum_flux, node_hspace, set_node_hspace, node_vspace, set_node_vspace) => {
    return [
        /* Couleur du fond de la page */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.BgC'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.BgC', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.BgC' },
                        t('MEP.tooltips.BgC'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'color', value: data.couleur_fond_sankey, onChange: evt => {
                            // const c=evt.target.checkeds
                            data.couleur_fond_sankey = evt.target.value;
                            set_data(Object.assign({}, data));
                        } })))),
        /* Quadrillage */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.TCG'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.TCG', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.TCG' },
                        t('MEP.tooltips.TCG'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "number", min: 1, max: 100, step: 1, value: data.grid_square_size, onChange: evt => {
                            data.grid_square_size = (+evt.target.value >= 1) ? +evt.target.value : 10;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.GV', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.GV' },
                        t('MEP.tooltips.GV'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', style: { marginRight: '0px', marginLeft: '-0.75em' }, checked: data.grid_visible, onChange: () => {
                            data.grid_visible = !data.grid_visible;
                            set_data(Object.assign({}, data));
                        } })))),
        /* Echelle du Sankey */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.Echelle'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.Echelle', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.Echelle' },
                        t('MEP.tooltips.Echelle'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: user_scale, onChange: evt => {
                            set_user_scale(+evt.target.value);
                        }, onBlur: () => {
                            data.user_scale = user_scale;
                            set_data(Object.assign({}, data));
                        } })),
                react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, null),
                react_1.default.createElement(react_bootstrap_1.Form.Text, null,
                    "(",
                    t('MEP.vp100'),
                    ")"))),
        /* Taille maximale du flux */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.MaxFlux'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.MaxFlux', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.MaxFlux' },
                        t('MEP.tooltips.MaxFlux'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: maximum_flux == null ? undefined : maximum_flux, onChange: evt => {
                            set_maximum_flux(+evt.target.value);
                        }, onBlur: () => {
                            data.maximum_flux = maximum_flux;
                            set_data(Object.assign({}, data));
                        } })))),
        /* Ecart horizontal  */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.Horizontal'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.EEN_h', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-adjust' },
                        t('Menu.tooltips.EEN_h'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: node_hspace, onChange: evt => {
                            set_node_hspace(+evt.target.value);
                            data.h_space = +evt.target.value;
                        } })))),
        /* Ecart Vertical */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.Vertical'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.EEN_v', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.EEN_v' },
                        t('MEP.tooltips.EEN_v'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: node_vspace, onChange: evt => {
                            set_node_vspace(+evt.target.value);
                            data.v_space = +evt.target.value;
                        } })))),
        /* Positionnement des noeuds */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.PA', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.PA' },
                        t('MEP.tooltips.PA'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            SankeyLayout_1.compute_auto_sankey(data, node_hspace);
                            set_data(Object.assign({}, data));
                        } }, t('MEP.PA')))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.AN', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.AN' },
                        t('MEP.tooltips.AN'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            SankeyLayout_1.arrangeNodes(data);
                            set_data(Object.assign({}, data));
                        } }, t('MEP.AN')))))
    ];
};
exports.OpenSankeyMenuConfigurationLayout = OpenSankeyMenuConfigurationLayout;
